import type { SessionStatus } from "../api/types";

const labels: Record<SessionStatus, string> = {
  UPLOADING: "上传中",
  VERIFYING: "校验中",
  READY: "可回放",
  FAILED: "失败",
  DELETING: "删除中",
};

export function StatusBadge({ status }: { status: SessionStatus }) {
  return <span className={`status status-${status.toLowerCase()}`}>{labels[status]}</span>;
}
